module.exports = __webpack_public_path__ + "static/03-d5a5f2dd4324833921a8235ed0eaa42d.jpg";